const DashboardIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <g id="Group_7083" data-name="Group 7083">
                <rect
                    id="Rectangle_1072"
                    data-name="Rectangle 1072"
                    width="8.667"
                    height="8.667"
                    rx="2"
                    transform="translate(11 0.333)"
                    fill="#d6d6d6"
                />
                <rect
                    id="Rectangle_1073"
                    data-name="Rectangle 1073"
                    width="8.667"
                    height="8.667"
                    rx="2"
                    transform="translate(11 0.333)"
                    fill="none"
                    stroke="#d6d6d6"
                    strokeWidth="1"
                />
                <rect
                    id="Rectangle_1074"
                    data-name="Rectangle 1074"
                    width="8.667"
                    height="8.667"
                    rx="2"
                    transform="translate(0.333 0.333)"
                    fill="none"
                    stroke="#0c3b8d"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_3554"
                    data-name="Path 3554"
                    d="M2,0H6.667a2,2,0,0,1,2,2V6.667a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
                    transform="translate(0.333 11)"
                    fill="none"
                    stroke="#0c3b8d"
                    strokeWidth="0.75"
                />
                <rect
                    id="Rectangle_1076"
                    data-name="Rectangle 1076"
                    width="8.667"
                    height="8.667"
                    rx="2"
                    transform="translate(11 11)"
                    fill="none"
                    stroke="#0c3b8d"
                    strokeWidth="0.75"
                />
            </g>
        </svg>
    );
};

export default DashboardIcon;
